import { Flex } from '@aloft/toolkit-sui';

import { useCallback } from 'react';
import { Tooltip, TooltipContentProps } from 'recharts';

type GraphTooltipWrapperProps = {
  children:
    | React.ReactNode
    | ((props: TooltipContentProps<string | number, string>) => React.ReactNode);
  disableAnimations: boolean;
};

export const GraphTooltipWrapper = ({ children, disableAnimations }: GraphTooltipWrapperProps) => {
  const TooltipContent = useCallback(
    (props: TooltipContentProps<string | number, string>) => {
      const { active, payload } = props;
      if (!active || !payload || !payload.length) return null;

      // Don't show tooltip for exponential fit lines
      if ((payload[0] as { name?: string }).name === 'Exponential Fit') return null;

      return (
        <Flex
          flexDirection="column"
          gap="0.5rem"
          padding="0.5rem"
          alignItems="flex-start"
          backgroundColor="surface1"
          border="1px solid"
          borderColor="strokeActive"
          borderRadius="4px"
        >
          {typeof children === 'function' ? children(props) : children}
        </Flex>
      );
    },
    [children, disableAnimations],
  );

  return !disableAnimations && <Tooltip content={TooltipContent} />;
};
